import { z } from 'zod';

import { makeEndpoint } from '../common';

export enum WaitlistMode {
  AUTO = 'auto',
  MANUAL = 'manual',
  NONE = 'none',
}

export const WaitlistSchema = z
  .object({
    id: z.string().uuid(),
    claimTime: z.number().nullable(),
    mode: z.nativeEnum(WaitlistMode),
    shouldShowRemovedEntries: z.boolean(),
  })
  .strict();

const UpdateWaitlistRequestSchema = WaitlistSchema.omit({ id: true }).partial();

export const UpdateWaitlistEndpoint = makeEndpoint({
  method: 'PATCH',
  url: ({ brandId, waitlistId }: { brandId: string; waitlistId: string }) => `/v1/brands/${brandId}/waitlists/${waitlistId}`,
  requestSchema: UpdateWaitlistRequestSchema,
  responseSchema: z.void(),
});

export const GetWaitlistEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, waitlistId }: { brandId: string; waitlistId: string }) => `/v1/brands/${brandId}/waitlists/${waitlistId}`,
  requestSchema: z.void(),
  responseSchema: WaitlistSchema,
});

export const PublicWaitlistSchema = WaitlistSchema.omit({ claimTime: true });

export const PublicGetWaitlistEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, waitlistId }: { brandId: string; waitlistId: string }) => `/v1/brands/${brandId}/waitlists/${waitlistId}`,
  requestSchema: z.void(),
  responseSchema: PublicWaitlistSchema,
});
